/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface TypeCoursSearch
 */
export interface TypeCoursSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeCoursSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeCoursSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof TypeCoursSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeCoursSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TypeCoursSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TypeCoursSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypeCoursSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TypeCoursSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TypeCoursSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TypeCoursSearch interface.
 */
export function instanceOfTypeCoursSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeCoursSearchFromJSON(json: any): TypeCoursSearch {
    return TypeCoursSearchFromJSONTyped(json, false);
}

export function TypeCoursSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeCoursSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TypeCoursSearchToJSON(value?: TypeCoursSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'libelle': TextSearchToJSON(value.libelle),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

